//npm packages
import React from 'react';
import Select from 'react-select';
import consts from '../../consts';

/**
 * Converts simple value to object for consumption by react-select
 * @param {any} value simple value such as id or option such as {LookupId: 5}
 * @param {Object} options
 * @param {Boolean} isMulti
 * @param {String} valueProp
 */
const getValue = (value, options, isMulti, valueProp) => {
  value = consts.LicenseTypeMappings[value] || value;
  let match;
  if (value === undefined || options === undefined) {
    return isMulti ? [] : '';
  }
  if (!options) {
    return value;
  }
  if (!Array.isArray(value) && typeof value === 'object') {
    return value;
  }
  if (
    Array.isArray(value) &&
    value.length !== 0 &&
    typeof value[0] !== 'string'
  ) {
    return value;
  }
  if (isMulti) {
    let val = (Array.isArray(value) && value) || value.split(',');
    match = options.filter(f => val.includes(f[valueProp].toString()));
  } else {
    match = options.find(t => t[valueProp] === value);
  }
  if (match) {
    return match;
  }
  return value;
};

/**
 * @desc  HOC for Select field
 * @param {Object} - component props
 */
export default ({ input, ...rest }) => {
  const {
    meta,
    options,
    placeholder,
    isMulti = false,
    isDisabled = false,
    isClearable = false,
    valueProp = 'value',
    defaultValue,
    menuPortalTarget
  } = rest || {};
  const { touched, error, warning } = meta || {};
  const { value, onBlur, ...restInput } = input || {};
  const selectValue = getValue(
    value || defaultValue,
    options,
    isMulti,
    valueProp
  );
  return (
    <div style={{ width: '100%' }}>
      <Select
        {...restInput}
        placeholder={placeholder}
        options={options}
        isDisabled={isDisabled}
        isMulti={isMulti}
        isClearable={isClearable}
        value={selectValue}
        menuPortalTarget={menuPortalTarget}
      />
      {touched &&
        ((error && <span className="required-color-red">{error}</span>) ||
          (warning && <span className="warning-color">{warning}</span>))}
    </div>
  );
};
